<template>
  <ul
    class="border-ontick-steel-300 bg-ontick-steel-100 dark:border-ontick-steel-600 dark:bg-ontick-steel-500 absolute overflow-hidden rounded-xl border shadow-lg"
    v-click-outside="closeDropdown"
  >
    <li>
      <button class="dropdown-item" @click.stop="openDetails({ extension_id: detailsId, partner_name: owner })">
        <i v-html="$icons.manage_search" class="dropdown-icon"></i>
        <span>Detalhes</span>
      </button>
    </li>
    <!-- <li>
      <button
        class="dropdown-item"
        @click.stop="openPreferencesModal(detailsId)"
      >
        <i v-html="$icons.tune" class="dropdown-icon"></i>
        <span>Preferências</span>
      </button>
    </li> -->
    <li v-if="isActive">
      <button class="dropdown-item" @click.stop="price ? goToSubscriptions() : deactivateExtension(detailsId)">
        <i v-if="price" v-html="$icons.settings_lg" class="dropdown-icon"></i>

        <i v-else v-html="$icons.delete_outline" class="text-ontick-red-600"></i>
        <span>{{ price ? "Gerenciar" : "Desativar" }}</span>
      </button>
    </li>
  </ul>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { mapActions } from "vuex";
export default {
  directives: {
    ClickOutside,
  },
  props: {
    detailsId: {
      type: Number,
    },
    isActive: {
      type: Boolean,
    },
    price: {
      type: Number,
    },
    owner: {
      type: String,
    },
  },
  data() {
    return {
      modalCustomClasses: {
        popup: "bg-ontick-graphite-600 py-10 rounded-lg",
        title: "text-gray-300 text-3xl font-bold",
        content: "text-gray-400",
        confirmButton: "bg-ontick-blue-600 py-2 px-6 text-ontick-carbon-900 confirm-button rounded-lg mx-1",
        cancelButton: "bg-transparent py-2 px-6 text-gray-300 border border-ontick-steel-400 rounded-lg mx-1",
      },
    };
  },

  methods: {
    ...mapActions({
      setDetailsIsActive: "extensions/setDetailsIsActive",
      setDetailsId: "extensions/setDetailsId",
      setPreferencesId: "extensions/setPreferencesId",
      setPreferencesModalIsActive: "extensions/setPreferencesModalIsActive",
    }),
    goToSubscriptions() {
      this.$router.push("/account?tag=signature");
    },
    closeDropdown() {
      this.$emit("close");
    },
    openDetails({ extension_id, partner_name }) {
      this.$router.push({
        name: "Detalhes da extensão",
        params: {
          extension_id,
          partner_name: partner_name.replaceAll(" ", "").toLowerCase(),
        },
      });
    },
    openPreferencesModal(id) {
      this.setPreferencesId(id);
      this.setPreferencesModalIsActive(true);
    },
    deactivateExtension(id) {
      this.$api
        .post(this.$endpoint.DISABLE_EXTENSION, {
          extension_id: id,
        })
        .then((res) => {
          // console.log(res.data);
          this.$swal({
            title: "Sucesso",
            text: res.data.msg,
            icon: "success",
            iconHtml: this.$icons.swal_success,
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal({
            title: "Erro",
            icon: "error",
            text: res.data.msg,
          });
        })
        .finally(() => {
          this.$emit("subscription");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  &-item {
    @apply text-ontick-carbon-900 hover:bg-ontick-steel-200 dark:hover:bg-ontick-steel-800 flex w-full items-center space-x-2 px-3 py-2 text-sm transition dark:text-gray-300;
  }
  &-icon {
    @apply text-ontick-blue-500;
  }
}
</style>
